var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishlistWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.001 3.81919C14.8197 1.30971 19.1756 1.39302 21.8907 4.09153C24.6059 6.79004 24.6991 11.0892 22.1739 13.8932L11.9997 24L1.82562 13.8932C-0.699529 11.0892 -0.605139 6.78324 2.10879 4.09153C4.82579 1.39677 9.17405 1.30599 12.001 3.81919Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistWhiteIcon);
export default __webpack_public_path__ + "static/media/wishlist_white_icon.800dfe6a1d8d79762dfdb39b464029d7.svg";
export { ForwardRef as ReactComponent };